import {Inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable, of} from 'rxjs';
import {
  Regulation,
  RegulationCreateRequest,
  RegulationCreateResponse,
  RegulationDetails,
  RegulationUpdateRequest,
  RegulationUpdateResponse
} from '@ms-organization-entities';
import {ApiClientConfig} from '../api-client-config';
import {ColumnWithLocalization} from "it/primatoo/openapi/api/org/schemas/common/ColumnWithLocalization";

import {PriorityPatchRequest} from '@primatoo-ms-organization';
import {DataProtectionGovernanceService} from '../interface/data-protection-governance-service';
import {TranslateService} from '@ngx-translate/core';
import {RegulationTypeEnum} from '@pt/pt-models';

@Injectable({
  providedIn: 'root'
})
export class RegulationService extends DataProtectionGovernanceService {

  private readonly endpoint: string;

  constructor(
    @Inject(ApiClientConfig) private config,
    public httpClient: HttpClient,
    private translateService: TranslateService
  ) {
    super(httpClient);
    this.endpoint = this.config.endPoint + '/api/org/regulations/';
  }


  public getRegulations(): Observable<Regulation[]> {
    const url = this.endpoint;
    return this.httpClient.get<Regulation[]>(url);
  }

  setPriority(id: number, request: PriorityPatchRequest): Observable<Regulation> {
    const url = `${this.endpoint}${id}/priority`;
    return this.httpClient.patch<Regulation>(url, request);
  }

  public findUserColumns(): Observable<ColumnWithLocalization[]> {
    const url = this.endpoint + `columns`;
    return this.httpClient.get<ColumnWithLocalization[]>(url);
  }

  // public updateUserColumns(columnsConfigurationUpsertRequest: ColumnsConfigurationUpsertRequest): Observable<void> {
  //   const url = this.endpoint + 'user-columns';
  //   return this.httpClient.post<void>(url, columnsConfigurationUpsertRequest);
  // }

  public getRegulationById(id: number): Observable<Regulation> {
    const url = this.endpoint + id + '/';
    return this.httpClient.get<Regulation>(url);
  }

  public getRegulationDetails(id: number): Observable<RegulationDetails> {
    const url = this.endpoint + id + '/details';
    return this.httpClient.get<RegulationDetails>(url);
  }

  public deleteRegulation(id: number): Observable<Regulation> {
    const url = this.endpoint + id + '/';
    return this.httpClient.delete<Regulation>(url);
  }

  public createRegulation(requestBody: RegulationCreateRequest): Observable<RegulationCreateResponse> {
    const url = this.endpoint;
    return this.httpClient.post<RegulationCreateResponse>(url, requestBody);
  }

  public updateRegulation(id: number, requestBody: RegulationUpdateRequest): Observable<RegulationUpdateResponse> {
    const url = this.endpoint + id + '/';
    return this.httpClient.put<RegulationUpdateResponse>(url, requestBody);
  }

  getEndPointV1(): string {
    return this.endpoint;
  }

  translateType(type: string) {
    switch (type) {
      case RegulationTypeEnum.INTERNAL_PROCEDURE:
      case RegulationTypeEnum.REGULATION:
        return this.translateService.stream('REGULATION_OPTIONS.' + type);
      default :
        return of(type);
    }
  }
}
